import _ from 'lodash';
import { FilterEqOperation } from '../types/types';
var PriceFilterModel = /** @class */ (function () {
    function PriceFilterModel(filterType, title, options) {
        this.filterType = filterType;
        this.selectedPrices = { minPrice: '', maxPrice: '' };
        this.title = title;
        this.options = options;
        this.selectedPrices.minPrice = this.minPrice = this.options[0].key;
        this.selectedPrices.maxPrice = this.maxPrice = this.options[this.options.length - 1].key;
    }
    PriceFilterModel.prototype.update = function (priceOption) {
        if (this.selectedPrices.minPrice !== priceOption.min) {
            this.selectedPrices.minPrice = priceOption.min;
        }
        if (this.selectedPrices.maxPrice !== priceOption.max) {
            this.selectedPrices.maxPrice = priceOption.max;
        }
    };
    PriceFilterModel.prototype.toDTO = function () {
        return {
            field: 'comparePrice',
            op: this.toOperationDTO(),
            values: _.compact([
                this.hasMinPrice() && this.selectedPrices.minPrice,
                this.hasMaxPrice() && this.selectedPrices.maxPrice,
            ]),
        };
    };
    PriceFilterModel.prototype.hasSelectedOptions = function () {
        return this.hasMinPrice() || this.hasMaxPrice();
    };
    PriceFilterModel.prototype.reset = function () {
        this.selectedPrices = { minPrice: '', maxPrice: '' };
    };
    PriceFilterModel.prototype.toOperationDTO = function () {
        var op;
        /* istanbul ignore else: todo(daniela): test this */
        if (this.hasMinPrice() && this.hasMaxPrice()) {
            op = FilterEqOperation.BETWEEN;
        }
        else if (this.hasMinPrice()) {
            op = FilterEqOperation.GTE;
        }
        else if (this.hasMaxPrice()) {
            op = FilterEqOperation.LTE;
        }
        return op;
    };
    PriceFilterModel.prototype.hasMinPrice = function () {
        return this.selectedPrices.minPrice && this.selectedPrices.minPrice !== this.minPrice;
    };
    PriceFilterModel.prototype.hasMaxPrice = function () {
        return this.selectedPrices.maxPrice && this.selectedPrices.maxPrice !== this.maxPrice;
    };
    return PriceFilterModel;
}());
export { PriceFilterModel };
//# sourceMappingURL=priceFilterModel.js.map